import { TaxRateSelect } from '@components'

import { Controller } from 'react-hook-form'

import { useFormContext } from '../../../../../../hooks/useForm'
import { VatSuggestionsFormSchema } from '../SuggestionsTable/utils/formSchema'

interface SuggestedVatDropdownProps {
  disabled?: boolean
  rowId: string
  initialSuggestedRate: string
}

export const SuggestedVatDropdown = ({ disabled, rowId, initialSuggestedRate }: SuggestedVatDropdownProps) => {
  const { control } = useFormContext<VatSuggestionsFormSchema>()

  return (
    <Controller
      control={control}
      name={`${rowId}.suggestedTaxRateId`}
      render={({ field: { value, onChange, ...props } }) => (
        <TaxRateSelect
          {...props}
          onSelect={(id) => {
            if (id) {
              onChange(id)
            }
          }}
          purchase
          disabled={disabled}
          selectedId={value || initialSuggestedRate}
          suggestedOption={initialSuggestedRate}
          autoCompleted={(value || initialSuggestedRate) === initialSuggestedRate}
          size="sm"
        />
      )}
    />
  )
}
